'use client'

import { ErrorDataUnavailable } from '@/components/common/Error'

const ChartAllocationHistoryError = () => {
  return (
    <div className="w-full" data-testid="allocation-history-error">
      <ErrorDataUnavailable minHeight="334px" />
    </div>
  )
}

export default ChartAllocationHistoryError
